import { Alert, Box, CircularProgress, Stack } from "@mui/material";
import { ScrapEyeDataDashboardDevice } from "components/scrapEyeDataDashboard/device/ScrapEyeDataDashboardDevice";
import { useTenantTranslation } from "hooks/formatters";
import { useTenant } from "hooks/settings";
import {
  ScrapEyeDevice,
  useListScrapEyeDevicesQuery,
} from "src/store/api/generatedApi";
import { ProvisionManualDeviceButton } from "components/scrapEyeDataDashboard/components/ProvisionManualDeviceButton";

const isOnlineExpected = (device: ScrapEyeDevice) =>
  device.installation_location != null;

const sortByExpectedStateThenName = (devices: readonly ScrapEyeDevice[]) =>
  [...devices].sort((a, b) => {
    const aOnline = isOnlineExpected(a);
    const bOnline = isOnlineExpected(b);
    if (aOnline && !bOnline) return -1;
    if (!aOnline && bOnline) return 1;
    return a.name.localeCompare(b.name);
  });

function Content() {
  const tenantName = useTenant();
  const { t } = useTenantTranslation();
  const { data, isLoading, isError, isFetching } = useListScrapEyeDevicesQuery({
    tenantName,
  });

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (isError || !data) {
    return <Alert severity="error">{t("errorLoadingDevices")}</Alert>;
  }

  const sortedDevices = sortByExpectedStateThenName(data.items);

  return (
    <Stack spacing={2}>
      <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 2 }}>
        <ProvisionManualDeviceButton />
      </Box>
      {sortedDevices.map((device) => (
        <ScrapEyeDataDashboardDevice
          key={device.id}
          device={device}
          isFetching={isFetching}
          isOnlineExpected={isOnlineExpected(device)}
        />
      ))}
    </Stack>
  );
}

export function ScrapEyeDataDashboardDeviceList() {
  return (
    <Box p={2}>
      <Content />
    </Box>
  );
}
